/**
 * Go through a tree and add changeTypes to the folders
 * based on the files they contain.
 *
 * A folder that contains updated files is always updated.
 * A folder that contains new files and no updated files is new.
 */
function addFolderChangeTypes(tree) {
  // I want to iterate over the tree, starting at the leaves,
  // and then working my way up. The order doesn't matter
  // as long as by the time I visit any node X, I have already
  // visited all of it's children, X.children.

  // Visit the tree in breadth-first order, adding each node to nodeList
  const stack = Array.from(tree);
  const nodeList = [];
  while (stack.length > 0) {
    const node = stack.pop();
    nodeList.push(node);
    if (node.children) {
      stack.push(...node.children);
    }
  }

  // Now reverse that node list to visit nodes in leaf-first order
  nodeList.reverse().forEach(node => {
    if (node.changeType) {
      return;
    }
    const hasUpdated = node.children.find(child => {
      return child.changeType === `updated`;
    });
    const hasNew = node.children.find(child => {
      return child.changeType === `new`;
    });
    if (hasUpdated) {
      node.changeType = `updated`;
      return;
    }
    if (hasNew) {
      node.changeType = `new`;
      return;
    }
    node.changeType = `unchanged`;
  });
}

function getParent(lastParent, sectionName, depth) {
  const nextParent = lastParent.find(potentialParent => {
    return potentialParent.name === sectionName;
  });
  if (nextParent) {
    return nextParent.children;
  }
  const newParent = {
    type: `folder`,
    name: sectionName,
    depth,
    children: []
  };
  lastParent.push(newParent);
  return newParent.children;
}

function pathDepth(x) {
  const match = x.match(/\//g);
  if (!match) {
    return 0;
  }
  return match.length;
}

function toTree(files) {
  files = files.sort((a, b) => {
    return pathDepth(a.path) < pathDepth(b.path);
  });
  const tree = [];
  files.forEach(file => {
    const sections = file.path.split(`/`);
    let parent = tree;

    sections.forEach((section, index) => {
      const isLastSection = index === sections.length - 1;

      if (!isLastSection) {
        parent = getParent(parent, section, index);
      } else {
        // add a file to 'parent'
        parent.push({
          type: `file`,
          name: section,
          depth: index,
          path: file.path,
          manual: file.manual,
          changeType: file.changeType
        });
      }
    });
  });

  addFolderChangeTypes(tree);

  return tree;
}
export default toTree;



// WEBPACK FOOTER //
// ./src/byos/logic/toTree.js